export default __webpack_public_path__ + "static/SR France - Mycotoxins - Statement-2485f1d6f3d924a10d3f285aa2ff6961.pdf";